/*eslint-env browser */
import * as React from 'react'
import cx from 'classnames'
import * as styles from '../filter.component.styl'
import Button from '@src/components/common/button'
import AccountFilter from './account.filter'
import type { History } from 'history'
import type { FilterAccount, FilterState } from '@src/redux/reducers/filter'
import type { FilterOption } from '../models'

export interface Props {
  history: History
  isActiveFilter?: boolean
  options: FilterState
  accountsList:
    | FilterOption[]
    | {
        [x: string]: FilterOption
      }
  onClose: () => void
  applyNow: (
    { currentAccount }: { currentAccount: FilterAccount },
    callback: () => void
  ) => void
  resetAll: (callback?: () => void) => void
}

const FilterOptions: React.FC<Props> = (props: Props) => {
  const { options, accountsList, isActiveFilter, onClose, applyNow } = props
  const wrapperRef = React.useRef(null)
  const [selectedAccount, selectAccount] = React.useState(
    options?.currentAccount
  )

  React.useEffect(() => {
    document.addEventListener('click', handleClickOutside)
    return () => {
      document.removeEventListener('click', handleClickOutside)
    }
  }, [])

  function handleClickOutside(event: MouseEvent) {
    if (wrapperRef && !wrapperRef?.current?.contains(event.target as Node)) {
      handleClose()
    }
  }

  function handleClose() {
    if (typeof onClose === 'function') {
      onClose()
    }
  }

  function onApplyNow() {
    if (typeof applyNow === 'function') {
      applyNow(
        {
          ...options,
          currentAccount: selectedAccount
        },
        () => {
          onClose()
        }
      )
    }
  }

  function onChangeAccountFilter(account: FilterOption) {
    selectAccount(account)
  }

  function onResetAll() {
    props.resetAll(() => {
      selectAccount(null)
    })
  }

  return (
    <div
      role={'accounts_menu'}
      className={styles.filterOptions}
      ref={wrapperRef}
    >
      <div role={'filter_account_menu_header'} className={styles.header}>
        <div role={'filter_account_menu_title'} className={styles.title}>
          Filter
        </div>
        <i
          role={'close'}
          onClick={handleClose}
          className={cx(styles.closeButton, 'material-icons')}
        >
          close
        </i>
      </div>
      <div role={'filter_account_menu_content'} className={styles.body}>
        <div role={'control_buttons'} className={styles.buttonRow}>
          <Button
            title="APPLY NOW"
            style="primary"
            icon={null}
            onClick={onApplyNow}
            disabled={!selectedAccount?.id}
          />

          <Button
            title="RESET ALL"
            icon={null}
            onClick={onResetAll}
            disabled={!isActiveFilter}
          />
        </div>
        <AccountFilter
          onChange={onChangeAccountFilter}
          selectedAccount={selectedAccount}
          accountsList={accountsList}
        />
        <div />
      </div>
    </div>
  )
}

export default FilterOptions
